<script>
export default {
  props: {
    userPreset: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      user: {},
      banRequestPending: false
    };
  },
  created() {
    this.user = this.userPreset;
  },
  methods: {
    refreshUser(options) {
      let params = {};

      if (options.with instanceof Array) {
        params.with = options.with;
      }

      return new Promise((resolve, reject) => {
        axios
          .get(`/api/users/${this.user.id}`, {
            params: params
          })
          .then(response => {
            this.user = response.data;
            this.$forceUpdate();
            resolve(this.user);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/mixins/HasUser.vue